<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      width="640px"
      :mask-closable="false"
      title="新增寄件信息"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="地址">
          <a-textarea
            v-decorator="['address', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入地址' },
                { max: 500, message: '最多500个字符' },
              ]
            }]"
            :rows="3"
            placeholder="详细寄件地址"
          />
        </a-form-item>
        <a-form-item label="联系人">
          <a-input
            v-decorator="['contact_name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入联系人' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input
            v-decorator="['contact_phone', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入联系电话' },
                { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确' },
              ]
            }]"
            placeholder="11位手机号"
            maxlength="11"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { createExpressSender } from '@/api/express_sender'
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'express_sender_new' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          createExpressSender(values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.form.resetFields()
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
